import styled from 'styled-components'
import { Views } from '../../enums'

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 36px;
  margin-right: 36px;
  margin-bottom: 36px;
  margin-left: 36px;

  ${({ color, view }) => view === Views.default && `
    width: 100%;
    max-width: 768px;
    min-height: 523px;
    max-height: auto;
    border-top: 10px solid ${color};
    @media(max-width: 767px) {
      margin-top: 10px;
      margin-bottom: 10px;
      min-height: auto;
    } 
  `}

  ${({ view }) => view !== Views.default && `
    width: 100%;
    max-width: 830px;
    max-height: 90%;
    height: 784px;
    min-height: auto;
    border-top: none;
    @media(max-width: 767px) {
      margin-top: 10px;
      margin-bottom: 10px;
    } 
  `}

  position: relative;
  background: #FFFFFF;
  border-radius: 5px;
  color: #1E1E1E;
  font-size: 14px;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  animation: fadeUp .3s ease 1;
  letter-spacing: initial;
  text-align: initial;
  text-transform: initial;
`

export default Container

interface ContainerProps {
  color: string
  view: Views
}